import { FormControlLabel } from "@material-ui/core";
import React from "react";
import Input from "../../../../../../components/Input";
import InputSelect from "../../../../../../components/Input-select";
import useAuthData from "../../../../../../hook/useAppData";
import { SwitchBlue } from "../../../../../../libs/switch";
import { getEletronicFilter } from "../../service";
import { caseFilter, optionSelectFilter, optionStatusFilter } from "../constants";
import useListEletronicStore from "../store/useStore";

export default function FilterEletronics() {
  const { token } = useAuthData();
  const { filterValue, filterSelect, selectFilterValue, inactiveOrActive } = useListEletronicStore();
  const {
    setFilterValue,
    setFilterSelect,
    setSelectFilterValue,
    setInactiveOrActive,
    setEtronicActived,
    setEletronicInactived,
    getEletronics,
    separateActiveFromInactiveEletronics,
    setPage,
  } = useListEletronicStore();

  async function handleClickFilter() {
    const SELECT_STATUS_NAME = optionStatusFilter[selectFilterValue - 1]?.name;
    const FILTERED_BY = caseFilter[filterSelect - 1];

    const queryString = gerateQueryString(SELECT_STATUS_NAME, FILTERED_BY);

    if (SELECT_STATUS_NAME === "Doado" || SELECT_STATUS_NAME === "Vendido") setInactiveOrActive(true);
    else setInactiveOrActive(false);

    const listFilter = await getEletronicFilter(token, queryString);
    const [eletronicActive, eletronicInactive] = separateActiveFromInactiveEletronics(listFilter?.eletronics);
    setEtronicActived(eletronicActive);
    setEletronicInactived(eletronicInactive);
  }

  function gerateQueryString(SELECT_STATUS_NAME, FILTERED_BY) {
    let queryString = "?";
    if (filterValue) queryString += `${FILTERED_BY}=${filterValue}&`;
    if (selectFilterValue) queryString += `status=${SELECT_STATUS_NAME}`;
    return queryString;
  }

  function handleCleanFilter() {
    setFilterValue("");
    setFilterSelect(0);
    setSelectFilterValue(0);
    getEletronics(token);
  }

  //switch control inactive active
  function setStateFunction() {
    setInactiveOrActive((oldState) => !oldState);
    setPage(0);
  }

  return (
    <>
      <div className="filterContainer nowrap-filter-row">
        <div className="rowFilterContainer">
          <Input
            name="immobilized"
            type="search"
            label="Buscar"
            placeholder="Busque um bem"
            value={filterValue}
            setValue={(event: any) => setFilterValue(event.target.value)}
            disabled={!!!filterSelect}
            list="dataList"
          />
          <InputSelect
            name="select"
            className="inputContainer"
            label="Filtro"
            placeholder="Selecionar"
            onChange={(event: any) => {
              setFilterSelect(event.target.value);
            }}
            list={optionSelectFilter}
            value={filterSelect}
          />
          <InputSelect
            name="select"
            className="inputContainer"
            label="Status"
            placeholder="Selecionar"
            list={optionStatusFilter}
            value={selectFilterValue}
            onChange={(event) => setSelectFilterValue(event.target.value)}
          />
          <div className="div-button-filter-eletronic filterContainer nowrap-filter-row">
            <div className="rowFilterContainer">
              <button className="btn filter-btn bg-primary m-top10" onClick={handleClickFilter}>
                Filtrar
              </button>
              <button className="Link btn bg-secondary m-top10" onClick={handleCleanFilter}>
                Limpar
              </button>
            </div>
          </div>
        </div>
        <div className="flex center">
          <FormControlLabel
            className="switch switch-collaborator m-top10"
            control={<SwitchBlue checked={inactiveOrActive} onChange={setStateFunction} name="checkedB" />}
            label="ver inativos"
          />
        </div>
      </div>
    </>
  );
}
